import styled from 'styled-components'
import { setVh } from '../../styles/utils/conversion.style'

export const SpacerVHMain = styled.div`
  display: block;
  ${({ value }) => `${setVh('height', value)}`}
`
